export default "/_next/static/images/Wire-3-e947c190e44b228c1e950b609545a03b.svg";